import * as React from 'react';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import { MeetingRequestResponseEditor } from 'owa-meeting-message';
import { observer } from 'mobx-react-lite';
import { MeetingRequestViewState } from '../store/schema/MeetingRequestViewState';
import isSenderSelf from 'owa-mail-store/lib/selectors/isSenderSelf';
import GroupsEventActionButton from './GroupsEventActionButton';
import MeetingRequestNoResponseButton from './MeetingRequestNoResponseButton';
import MeetingMessageActionEntrySource from '../store/schema/MeetingMessageActionEntrySource';

const styles = require('./MeetingMessageActions.scss');
const classNames = require('classnames');

export interface MeetingRequestInfoProps {
    item: MeetingRequestMessageType;
    viewState: MeetingRequestViewState;
    entrySource: MeetingMessageActionEntrySource;
    groupId?: string;
    onActionButtonClicked?: () => void;
}

const MeetingRequestInfo = observer(function MeetingRequestInfo(props: MeetingRequestInfoProps) {
    const { viewState, item, groupId, entrySource } = props;

    // Show meeting actions if user is not the organizer or if the user received it for a delegate
    const showMeetingActions = !isSenderSelf(item.Sender.Mailbox.EmailAddress) || item.IsDelegated;

    if (!viewState) {
        // Wait for viewstate initialization
        return null;
    }

    // Don't render meeting request actions if the current user is Sender
    return (
        <div>
            {showMeetingActions ? (
                <div className={classNames(styles.containerPadding, styles.container)}>
                    {groupId ? (
                        <GroupsEventActionButton
                            key="addToCalendar"
                            item={item}
                            viewState={viewState}
                            groupId={groupId}
                            entrySource={entrySource}
                        />
                    ) : item.MeetingRequestType === 'InformationalUpdate' ? (
                        <MeetingRequestNoResponseButton
                            item={props.item as MeetingRequestMessageType}
                            entrySource={entrySource}
                        />
                    ) : (
                        <MeetingRequestResponseEditor {...props} />
                    )}
                </div>
            ) : (
                <div className={styles.containerPadding} />
            )}
        </div>
    );
});
export default MeetingRequestInfo;
